module.exports = __webpack_public_path__ + "img/5-1.7441d4f5.jpg";